import VsimavecHead from '../../assets/vsimavec-head.svg';

export default function HeadLogo() {
    return (
        <img
            src={VsimavecHead}
            height="56"
            className="mb-4 h-14"
            alt="Všímavec"
        />
    );
}
